import React from 'react';

// import { TextField } from 'office-ui-fabric-react/lib/TextField';
import Threshold from './threshold';
import { ActionButton } from 'office-ui-fabric-react/lib/Button';
// import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
// import { Icon } from 'office-ui-fabric-react/lib/Icon';

// import { CHART_COLORS } from '../../../utilities/colors';

const thresholds = (props) => {
  const { 
    plot, 
    plotIndex, 
    addThreshold, 
    editThreshold, 
    removeThreshold, 
    clearThresholds, 
    saveThreshold, 
    updateSavedThreshold, 
    removeThresholdFromFavorites 
  } = props;

  const { thresholds } = plot;

  const myThresholds = []

  const defaultThresholds = []

  const tempThresholds = []

  thresholds.forEach((t, index) => {
    if(t.saved){ 
      myThresholds.push({...t, index}) 
    } else if(t.locked) { 
      defaultThresholds.push({...t, index}) 
    } else {
      tempThresholds.push({...t, index})
    }
  });

  return (
    <div className='thresholds panel-body' style={{width: '90%'}}>
      <div className='flex-buttons'>
        <ActionButton
          className='add-threshold'
          iconProps={{ iconName: 'AddTo' }}
          onClick={() => addThreshold(plotIndex)}
        >
          Add Threshold
        </ActionButton>
        <ActionButton
          className='clear-thresholds'
          iconProps={{ iconName: 'RemoveFilter' }}
          onClick={() => clearThresholds(plotIndex)}
        >
          Clear Thresholds
        </ActionButton>
      </div>
      {
        defaultThresholds && defaultThresholds.length > 0 && <div>
          <h5>Default Thresholds</h5>
          {
            defaultThresholds.map((props, index) => <Threshold 
              key={props.key}
              threshold={props} 
              plotIndex={plotIndex} 
              editThreshold={editThreshold} 
              removeThreshold={removeThreshold} 
              saveThreshold={saveThreshold}
              removeThresholdFromFavorites={removeThresholdFromFavorites}
              updateSavedThreshold={updateSavedThreshold}
            />)
          }
        </div>
      }
      {
        myThresholds && myThresholds.length > 0 && <div>
          <h5>My Thresholds</h5>
          {
            myThresholds.map((props) => <Threshold 
              key={props.key}
              threshold={props}
              plotIndex={plotIndex} 
              editThreshold={editThreshold} 
              removeThreshold={removeThreshold} 
              saveThreshold={saveThreshold}
              removeThresholdFromFavorites={removeThresholdFromFavorites}
              updateSavedThreshold={updateSavedThreshold}
            />)
          }
        </div>
      }
      {
        tempThresholds && tempThresholds.length > 0 && <div>
          <h5>Temporary Thresholds</h5>
          {
            tempThresholds.map((props) => <Threshold 
              key={props.key}
              threshold={props}
              plotIndex={plotIndex} 
              editThreshold={editThreshold} 
              removeThreshold={removeThreshold} 
              saveThreshold={saveThreshold}
              removeThresholdFromFavorites={removeThresholdFromFavorites}
              updateSavedThreshold={updateSavedThreshold}
            />)
          }
        </div>
      }
    </div>
  )
};

export default thresholds;


// WEBPACK FOOTER //
// ./src/components/panel/items/thresholds.js